import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { SdirCheckbox, Textarea } from '@sdir/sds';
import { ErrorWithTrace } from '@sdir/blueprint.aps/lib/components';
import { FileSelect } from '../../../Molecules';
import { VirtualFile } from '../../../../types/filegroup';

interface OverruleProps {
  availableFiles: VirtualFile[];
  checked: boolean;
  checkboxLabel?: string;
  comment?: string;
  error?: any;
  hideHeading?: boolean;
  showValidation?: boolean;
  onDeleteFile?: () => void;
  onNewFilesAdded: (files: File[]) => void;
  setOverruleChecked: (checked: boolean) => void;
  setOverruleComment: (value: string) => void;
  setShowOverruleValidation: (show: boolean) => void;
}

const Overrule: React.FC<OverruleProps> = ({
  availableFiles,
  checked = false,
  checkboxLabel,
  comment,
  error,
  hideHeading = false,
  showValidation,
  onDeleteFile,
  onNewFilesAdded,
  setOverruleChecked,
  setOverruleComment,
  setShowOverruleValidation,
}) => {
  const intl = useIntl();
  return (
    <OverruleWrapper>
      {!hideHeading && <h3>{intl.formatMessage({ id: 'qualification.overrule.title' })}</h3>}
      <SdirCheckbox
        checked={checked}
        title={checkboxLabel || intl.formatMessage({ id: 'qualification.overrule.toggle' })}
        onClick={() => setOverruleChecked(!checked)}
      />
      <OverruleFields>
        {checked && (
          <>
            <OverruleComment>
              <Textarea
                placeholder={intl.formatMessage({ id: 'qualification.overrule.comment' })}
                contentValue={comment}
                onChange={(e) => {
                  const value = e?.target?.value;
                  setOverruleComment(value);
                  if (value) {
                    setShowOverruleValidation(false);
                  }
                }}
                error={
                  showValidation ? intl.formatMessage({ id: 'general.form.error' }) : undefined
                }
              />
            </OverruleComment>
            <FileSelect
              availableFiles={availableFiles}
              selectedFileOption={null}
              onSelectFile={() => {}}
              onNewFilesAdded={onNewFilesAdded}
              onDeleteFile={onDeleteFile}
              deleteAny
              showWhenEmpty
            />
          </>
        )}
      </OverruleFields>
      {error && <ErrorWithTrace error={error} trace={error?.response?.headers?.traceresponse} />}
    </OverruleWrapper>
  );
};

export default Overrule;

const OverruleWrapper = styled.div``;
const OverruleFields = styled.div`
  margin-bottom: 20px;
`;
const OverruleComment = styled.div`
  max-width: 600px;
  margin: 20px 0;
`;
